import type { SearchQuizsetRes } from '@/api/gen/_model/searchQuizsetRes';
import type { QuizListItemProps } from '@/shared/quizList/hooks';
import { QuizListItem } from '@/shared/quizList/QuizListItem';
import { FolderCard } from '../../quiz-folder';
import type { LibraryItem } from '../types/library.types';
interface LibraryListItemProps {
  item: LibraryItem;
  /** 퀴즈 행에만 호출된다. 폴더 행을 그릴 때 퀴즈 전용 값을 만들지 않게 콜백으로 받는다. */
  quizProps: (quiz: SearchQuizsetRes) => Omit<QuizListItemProps, 'quizSet'>;
  /** 목록 안 순번(0부터). 폴더 카드의 노출·클릭에 싣는다. */
  position: number;
}

/** 자료실 한 줄. 콘텐츠 종류에 따른 분기는 여기서 끝난다. */
export const LibraryListItem = ({
  item,
  quizProps,
  position
}: LibraryListItemProps) => {
  if (item.kind === 'FOLDER') {
    return <FolderCard showAuthor folder={item.folder} href={`/folder/${item.id}`} place={'library'} position={position} />;
  }
  return <QuizListItem {...quizProps(item.quiz)} quizSet={item.quiz} data-sentry-element="QuizListItem" data-sentry-component="LibraryListItem" data-sentry-source-file="LibraryListItem.tsx" />;
};